module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox",
    class: {
      'has-success': _vm.value, 'has-danger': !_vm.value
    }
  }, [_c('input', {
    ref: _vm.name,
    style: (_vm.styler),
    attrs: {
      "type": "checkbox",
      "id": _vm.name,
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "col-form-label has-success"
  }, [_vm._v("   Critical")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }],
    staticClass: "col-form-label has-danger"
  }, [_vm._v("   Non Critical")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad76a5b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Form/CriticalFormCheckbox.vue
// module id = 641
// module chunks = 1